import { isValidInstanceName, storeInstanceName } from '../lib/oidc/oidcAuthInfo.ts';

const CAME_FROM_INSTANCE_SEARCH_PARAM = 'came_from_instance';

export const supportCameFromInstanceCustomDomain = () => {
  const instance = new URLSearchParams(window.location.search).get(CAME_FROM_INSTANCE_SEARCH_PARAM);

  if (instance && isValidInstanceName(instance)) {
    storeInstanceName(instance);
  }
};
